var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-tabs",
        {
          staticClass: "mb-0",
          attrs: {
            flat: "",
            "background-color": "transparent"
          }
        },
        [
          _c("v-tabs-slider", {
            attrs: {
              color: "green"
            }
          }),
          _c(
            "v-tab",
            {
              attrs: {
                to: {
                  name: "affiliates"
                },
                exact: ""
              }
            },
            [_vm._v(" Dashboard ")]
          ),
          _c(
            "v-tab",
            {
              attrs: {
                to: {
                  name: "affiliates_banners"
                },
                exact: ""
              }
            },
            [_vm._v(" Banners ")]
          ),
          _c(
            "v-tab",
            {
              attrs: {
                to: {
                  name: "affiliates-campaigns"
                },
                exact: ""
              }
            },
            [_vm._v(" Campaigns ")]
          ),
          _c(
            "v-menu",
            {
              attrs: {
                "offset-y": ""
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function fn(_ref) {
                    var on = _ref.on,
                      attrs = _ref.attrs
                    return [
                      _c(
                        "v-tab",
                        _vm._g({}, on),
                        [
                          _vm._v(" Statistics "),
                          _c("v-icon", [_vm._v("mdi-menu-down")])
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c(
                "v-list",
                {
                  staticClass: "grey lighten-3"
                },
                [
                  _c(
                    "v-list-item",
                    {
                      attrs: {
                        to: {
                          name: "monthly-statistics"
                        }
                      }
                    },
                    [_c("v-list-item-title", [_vm._v("Monthly Statistics")])],
                    1
                  ),
                  _c(
                    "v-list-item",
                    {
                      attrs: {
                        to: {
                          name: "yearly-statistics"
                        }
                      }
                    },
                    [_c("v-list-item-title", [_vm._v("Yearly Statistics")])],
                    1
                  ),
                  _c(
                    "v-list-item",
                    {
                      attrs: {
                        to: {
                          name: "lifetime-statistics"
                        }
                      }
                    },
                    [_c("v-list-item-title", [_vm._v("Lifetime Statistics")])],
                    1
                  ),
                  _c(
                    "v-list-item",
                    {
                      attrs: {
                        to: {
                          name: "traffic-details"
                        }
                      }
                    },
                    [_c("v-list-item-title", [_vm._v("Traffic Details")])],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-tab",
            {
              attrs: {
                to: {
                  name: "affiliates_payments"
                },
                exact: ""
              }
            },
            [_vm._v(" Payment History ")]
          ),
          _c(
            "v-menu",
            {
              attrs: {
                "offset-y": ""
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function fn(_ref2) {
                    var on = _ref2.on,
                      attrs = _ref2.attrs
                    return [
                      _c(
                        "v-tab",
                        _vm._g({}, on),
                        [
                          _vm._v(" Legal "),
                          _c("v-icon", [_vm._v("mdi-menu-down")])
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c(
                "v-list",
                {
                  staticClass: "grey lighten-3"
                },
                [
                  _c(
                    "v-list-item",
                    {
                      attrs: {
                        to: {
                          name: "affiliates_legal_tos"
                        }
                      }
                    },
                    [_c("v-list-item-title", [_vm._v("Affiliate ToS")])],
                    1
                  ),
                  _c(
                    "v-list-item",
                    {
                      attrs: {
                        to: {
                          name: "affiliates_legal_ftc"
                        }
                      }
                    },
                    [_c("v-list-item-title", [_vm._v("FTC Guidelines")])],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("hr", {
        staticClass: "mt-0 mb-md-4"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }